import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import Layout from './Layout.js';
import Formwizard from '../../../wizard/index.js';
import { jsx } from '@emotion/react';
var Default = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(Layout, {
    ref: ref
  }, jsx(Formwizard, props));
});
export { Default as default };